<template>
  <div >
    <van-tabs v-model="active" animated >
      <van-tab title="重置医院" >
        <van-form>
          <base-input v-model="qc.name" :rules="rules.name" placeholder="请输入员工姓名" label="员工姓名" @focus="xa" />
          <base-input v-model="qc.id_card" disabled placeholder="身份证号" label="身份证号" />
          <van-field
            v-model="hos.yy1"
            :rules="[{ required: true, message: '请填写定点医院名称1！' }]"
            center
            clearable
            label="定点医院1"
          >
            <template #button>
              <van-button size="small" type="info" @click="dy2(hos.yy1, 1)">搜索</van-button>
            </template>
          </van-field>

          <van-field
            v-model="hos.yy2"
            :rules="[{ required: true, message: '请填写定点医院名称2！' }]"
            center
            clearable
            label="定点医院2"
          >
            <template #button>
              <van-button size="small" type="info" @click="dy2(hos.yy2, 2)">搜索</van-button>
            </template>
          </van-field>

          <van-field
            v-model="hos.yy3"
            :rules="[{message: '请填写定点医院名称！' }]"
            center
            clearable
            label="定点医院3"
            placeholder="请输入定点医院名称"
          >
            <template #button>
              <van-button size="small" type="info" @click="dy2(hos.yy3, 3)">搜索</van-button>
            </template>
          </van-field>

          <van-field
            v-model="hos.yy4"
            :rules="[{ message: '请填写定点医院名称！' }]"
            center
            clearable
            label="定点医院4"
            placeholder="请输入定点医院名称"
          >
            <template #button>
              <van-button size="small" type="info" @click="dy2(hos.yy4, 4)">搜索</van-button>
            </template>
          </van-field>

          <van-field
            v-model="hos.yy5"
            :rules="[{ message: '请输入社区医院名称' }]"
            center
            clearable
            label="社区医院"
            placeholder="请输入社区医院名称"
          >
            <template #button>
              <van-button size="small" type="info" @click="dy2(hos.yy5, 5)">搜索</van-button>
            </template>
          </van-field>
          <br>
          <van-row
            type="flex"
            justify="space-between"
            style="text-align: center; padding-bottom: 10px;"
          >
            <van-col span="12">
              <van-button type="info" @click="cancel">取消</van-button>
            </van-col>
            <van-col span="12">
              <van-button type="info" native-type="submit" @click="submit">提交</van-button>
            </van-col>
          </van-row>
        </van-form>
      </van-tab>

    </van-tabs>
    <van-popup v-model="showPicker" round position="bottom"><van-picker :columns="columns" show-toolbar @cancel="showPicker = false" @confirm="onConfirm" /></van-popup>
    <div>
      <van-popup v-model="showA" round position="bottom">
        <van-search v-model="emp.value" show-action label="姓名" placeholder="请输入搜索关键词" @search="onSearch">
          <template #action>
            <div @click="onSearch">搜索</div>
          </template>
        </van-search>
        <van-picker :columns="emp_name" show-toolbar @cancel="showA = false" @confirm="SonConfirm" />
      </van-popup>
    </div>
  </div>
</template>

<script>
import { Wxlist, Wxmodify, WxEmpAdd } from '@/api/Hremployee';
import { billadd } from '@/api/Hrbill';
import { WxSocList } from '@/api/Hrfund';
export default {
  name: 'HosUpdate',
  props: {
    qc: {
      type: Object,
      default: function() {
        return {};
      }
    }
  },
  data() {
    return {
      activeNames: ['1'],
      yy1: '',
      columns: [],
      hos: {
        yy1: '',
        yy2: '',
        yy3: '',
        yy4: '',
        yy5: ''

      },
      showPicker: false,
      active: '',
      showA: false,
      emp: {
        value: '',
        disabled: true
      },
      empList: [],
      emp_name: [],
      hospital: {},
      rules: {
        name: [{ required: true, pattern: this.CONST.REG_EXP.PERSON_NAME, message: '姓名不能少于2个字符' }]

      }
    };
  },
  beforeMount() {
    if (sessionStorage.getItem('who') === '0') {
      this.emp.disable = false;
      this.qc.name = '';
      this.emp.status = 2;
      this.qc.id_card = '';
      this.qc.apply_salary = '';
      this.query();
    } else {
      this.qc.emp_id = parseInt(sessionStorage.getItem('emp_id'));
      this.qc.name = sessionStorage.getItem('username');
      this.qc.id_card = sessionStorage.getItem('id_card');
      this.emp.disable = true;
      this.quers();
    }
  },
  methods: {
    xa() {
      this.showA = true;
      this.queryX();
    },
    onSearch() {
      this.queryX();
    },
    queryX() {
      this.emp_name = [];
      this.empList = [];
      Wxlist({ client_id: parseInt(sessionStorage.getItem('client_id')), name: this.emp.value ? this.emp.value : null }).then(res => {
        for (let i = 0; i < res.rows.length; i++) {
          // this.emp_name.push({ text: res.rows[i].name, disabled: true });
          if (res.rows[i].function_ids.indexOf('10') !== -1 && res.rows[i].s_base > 0 && res.rows[i].status === 1) {
            this.empList.push({
              id: res.rows[i].id,
              id_card: res.rows[i].id_card,
              name: res.rows[i].name,
              phone: res.rows[i].phone,
              client_id: res.rows[i].client_id
            });
            this.emp_name.push({ text: res.rows[i].name, disabled: false });
            // this.emp_name[i].disabled = false;
          }
        }
      });
    },
    dy2(value, value2) {
      if (value.length < 2) {
        this.$toast.fail('请至少输入两个字符');
      } else {
        this.showPicker = true;
      }
      switch (value2) {
        case 1:
          this.query(value, 1);
          break;
        case 2:
          this.query(value, 2);
          break;
        case 3:
          this.query(value, 3);
          break;
        case 4:
          this.query(value, 4);
          break;
        case 5:
          this.query(value, 5);
          break;
      }
    },
    SonConfirm(value, index) {
      this.showA = false;
      if (this.empList[index].name !== undefined) {
        this.qc.name = this.empList[index].name;
      }
      if (this.empList[index].id !== undefined) {
        this.qc.emp_id = this.empList[index].id;
      }
      if (this.empList[index].id_card !== undefined) {
        this.qc.id_card = this.empList[index].id_card;
      }
      // 查询该名员工的历史医院信息
      // WxSocList({ emp_id: this.empList[index].id }).then(res => {
      //   this.hospital = res.rows[0];
      //   this.hos.yy1 = res.rows[0].hospital_1 !== undefined ? res.rows[0].hospital_1 : '';
      //   this.hos.yy2 = res.rows[0].hospital_2 !== undefined ? res.rows[0].hospital_2 : '';
      //   this.hos.yy3 = res.rows[0].hospital_3 !== undefined ? res.rows[0].hospital_3 : '';
      //   this.hos.yy4 = res.rows[0].hospital_4 !== undefined ? res.rows[0].hospital_4 : '';
      //   this.hos.yy5 = res.rows[0].hospital_5 !== undefined ? res.rows[0].hospital_5 : '';
      // });
    },
    onConfirm(value) {
      switch (this.id) {
        case 1:
          this.hos.yy1 = value;
          this.showPicker = false;
          break;
        case 2:
          this.hos.yy2 = value;
          this.showPicker = false;
          break;
        case 3:
          this.hos.yy3 = value;
          this.showPicker = false;
          break;
        case 4:
          this.hos.yy4 = value;
          this.showPicker = false;
          break;
        case 5:
          this.hos.yy5 = value;
          this.showPicker = false;
          break;
      }
    },
    query(name, id) {
      this.columns = [];
      this.axios
        .post('/client-hospital/wx-getList', {
          name: name,
          token: sessionStorage.getItem('token')
        })
        .then(res => {
          const len = res.data.rows.length;
          let i = 0;
          for (i; i < len; i++) {
            this.columns.push(res.data.rows[i].name);
          }
          this.id = id;
        });
    },
    cancel() {
      this.$emit('close');
    },
    quers() {
      WxSocList({ emp_id: parseInt(sessionStorage.getItem('emp_id')) }).then(res => {
        this.hospital = res.rows[0];
        this.hos.yy1 = res.rows[0].hospital_1 !== undefined ? res.rows[0].hospital_1 : '';
        this.hos.yy2 = res.rows[0].hospital_2 !== undefined ? res.rows[0].hospital_2 : '';
        this.hos.yy3 = res.rows[0].hospital_3 !== undefined ? res.rows[0].hospital_3 : '';
        this.hos.yy4 = res.rows[0].hospital_4 !== undefined ? res.rows[0].hospital_4 : '';
        this.hos.yy5 = res.rows[0].hospital_5 !== undefined ? res.rows[0].hospital_5 : '';
      });
    },
    submit() {
      if (this.qc.name !== '' && this.hos.yy1 !== '' && this.hos.yy2 !== '') {
        var jx = '';
        if (this.hos.yy1 !== '' && this.hos.yy1 !== this.hospital.hospital_1) {
          jx += ('修改医院为:1' + this.hos.yy1 + ',');
        } if (this.hos.yy2 !== '' && this.hos.yy2 !== this.hospital.hospital_2) {
          jx += ('2' + this.hos.yy2 + ',');
        } if (this.hos.yy3 !== '' && this.hos.yy3 !== this.hospital.hospital_3) {
          jx += ('3' + this.hos.yy3 + ',');
        } if (this.hos.yy4 !== '' && this.hos.yy4 !== this.hospital.hospital_4) {
          jx += ('4' + this.hos.yy4 + ',');
        } if (this.hos.yy5 !== '' && this.hos.yy5 !== this.hospital.hospital_5) {
          jx += ('5' + this.hos.yy5 + '.');
        }
        if (jx !== '') {
          billadd({
            client_id: parseInt(sessionStorage.getItem('client_id')),
            emp_id: parseInt(this.qc.emp_id),
            type: '社保-定点医院变更',
            create_id: parseInt(sessionStorage.getItem('create_id')),
            status: 6,
            feedback: jx,
            id_card: this.qc.id_card ? this.qc.id_card : null,
            check_type: 2
          }).then(resp => {
            if (resp.success) {
              this.$toast.success(resp.msg);
              if (sessionStorage.getItem('who') === '0') {
                this.qc.name = '';
              }
              this.$toast.success('提交成功');
              this.quers();
              this.$emit('close');
            } else {
              this.$toast.fail('提交失败');
            }
          });
        }
      }
    }
  }
};
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/hr/social/hos-update.vue